//dependencies
import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";

import { Alert } from "@performyard/py-components";

//utils
import { ReviewQuestion } from "../../../utils";

//store
import { useEditFormStore } from "../../../useEditFormStore";

const CalculatorQuestion = ({ data }: { data: ReviewQuestion }) => {
	const [ref] = useAutoAnimate();
	const questionsMap = useEditFormStore((state) => {
		return state?.questions?.reduce((acc, question) => {
			acc[question.refId] = question;
			return acc;
		}, {});
	});

	const hasQuestions = data.questions && data.questions.length > 0;

	// Some numeric calculation questions have no questions. The error state is handled by the parent, since this component is only a preview.
	if (!hasQuestions) {
		return null;
	}

	return (
		<div className="flex flex-col gap-4">
			{data?.is_hidden && (
				<Alert
					message="This calculation is hidden on review forms for all users"
					type="success"
					dangerouslySetClassName="w-full pt-2"
					weight="semi-bold"
					items="start"
				/>
			)}
			<div className="flex flex-col gap-2" ref={ref}>
				{data.questions &&
					data.questions.map((question, index) => (
						<div
							key={`${question.refId}-${index}-preview`}
							className="flex flex-col gap-2 rounded-[4px] bg-neutral-1 p-2"
						>
							<p className="line-clamp-2 max-w-full overflow-hidden text-wrap break-words">
								<span className="shrink text-paragraph-3 font-semibold">Question: </span>
								{questionsMap[question.refId]?.question}
							</p>
							<div className="flex items-center gap-2">
								<p className="text-paragraph-3 font-semibold">
									Weight: <span className="font-regular">{question.weight}</span>
								</p>
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default CalculatorQuestion;
